import { useEffect, useMemo, useState } from "react";
// import { useAnalytics } from "@c4c-web/core/hooks/analytics";
// import {
//   EAnalyticsEventAction,
//   EAnalyticsEvent,
//   EAnalyticsEventCategory,
// } from "@c4c-web/core/constants";
import type {
  IGoogleMapHookProps,
  IGoogleMapHookReturn,
  ILocation,
} from "../types";
// import { EAnalyticsEventLabel, EAnalyticsScreenName } from "../constants";
import {
  // getDefaultAddressAnalyticsParams,
  onMapCenterChanged,
  onMapLoad,
  setFormattedAddressFromCoordinates,
} from "../utils";
import { useCoverageArea } from "./useCoverageArea";

export const useGoogleMap = ({
  countryOfOperationID,
  defaultLocation,
  id,
  onAreaSupportedChange,
  searchBarRef,
  setAddressInfo,
  setCoordinates,
  setEmirate,
  setIsSelected,
  setTown,
}: IGoogleMapHookProps): IGoogleMapHookReturn => {
  const [updatedLocation, setUpdatedLocation] =
    useState<ILocation>(defaultLocation);
  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);
  const [showPin, setShowPin] = useState(true);

  const { isAreaSupported, checkCoverageArea } = useCoverageArea();
  // const { sendEvent } = useAnalytics();

  const options = useMemo(() => {
    return countryOfOperationID
      ? {
          componentRestrictions: { country: countryOfOperationID },
        }
      : {};
  }, [countryOfOperationID]);

  const checkAreaSupport = (lat: number, lng: number): void => {
    void checkCoverageArea(lat, lng);
  };

  useEffect(() => {
    if (onAreaSupportedChange && typeof isAreaSupported === "boolean") {
      onAreaSupportedChange(isAreaSupported);
    }
  }, [isAreaSupported, onAreaSupportedChange]);

  const setFormattedAddress = (
    { lat, lng }: { lat: number; lng: number },
    forceUpdate: boolean,
  ): void => {
    setFormattedAddressFromCoordinates({
      lat,
      lng,
      forceUpdate,
      setAddressInfo,
      setEmirate,
      setTown,
      checkAreaSupport,
    });
  };

  const onUnmount = (): void => {
    setMapInstance(null);
  };

  const onLoad = (map: google.maps.Map): void => {
    onMapLoad({
      map,
      searchBarRef,
      options,
      setIsSelected,
      setCoordinates,
      setUpdatedLocation,
      setFormattedAddress,
      checkAreaSupport,
      setMapInstance,
      // sendEvent,
    });
  };

  const onCenterChanged = (): void => {
    onMapCenterChanged({
      mapInstance,
      setShowPin,
      updatedLocation,
      setCoordinates,
      setUpdatedLocation,
      setFormattedAddress,
      checkAreaSupport,
      // sendEvent,
    });
  };

  const onDragging = (): void => {
    // sendEvent(
    //   {
    //     event: EAnalyticsEvent.Custom,
    //     event_action: EAnalyticsEventAction.AddressJourney,
    //     event_category: EAnalyticsEventCategory.UserEngagement,
    //     event_label: EAnalyticsEventLabel.AddressPinDragged,
    //   },
    //   getDefaultAddressAnalyticsParams(
    //     EAnalyticsScreenName.AddDeliveryLocationUserSearchesForLocation,
    //   ),
    // );
  };

  useEffect(() => {
    if (id && mapInstance) {
      setFormattedAddress(
        {
          lat: updatedLocation.lat,
          lng: updatedLocation.lng,
        },
        true,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- unnecessary dependency
  }, [id, mapInstance]);

  return {
    updatedLocation,
    showPin,
    setShowPin,
    onLoad,
    onUnmount,
    onCenterChanged,
    onDragging,
    setFormattedAddress,
    isAreaSupported,
  };
};
